import { AnimatePresence } from 'framer-motion'
import { PropsWithChildren, useEffect, useRef, useState } from 'react'

import { Loader } from '@ds'
import { useAppIsLoadingState } from '@store'

const MIN_VISIBLE_TIME = 600

export const LoaderProvider = ({ children }: PropsWithChildren) => {
  const isLoading = useAppIsLoadingState()
  const [visible, setVisible] = useState(false)

  const showStartTime = useRef<number | null>(null)

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>

    if (isLoading) {
      setVisible(true)
      showStartTime.current = Date.now()
    } else if (showStartTime.current && visible) {
      const elapsed = Date.now() - showStartTime.current
      const remainingTime = Math.max(0, MIN_VISIBLE_TIME - elapsed)

      timer = setTimeout(() => {
        setVisible(false)
        showStartTime.current = null
      }, remainingTime)
    }

    return () => clearTimeout(timer)
  }, [isLoading, visible])

  return (
    <>
      {children}
      <AnimatePresence>{visible && <Loader />}</AnimatePresence>
    </>
  )
}
